"use strict";
var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");

var template = require("../templates/classification-template.html");

/**
 * Retronews ClassificationView: display classification datas
 * Triggers:
 */
module.exports = Backbone.View.extend({

    template: _.template(template),
    model: null, // DocumentModel
    pageModel: null, // page model of current page

    events: {
        "click li": "onTagClicked"
    },

    initialize: function(options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.model, "change:page", T.onPageChanged);
    },

    render: function() {
        var T = this;

        if (!T.pageModel) {
            return;
        }

        var context = T.pageModel.toJSON();

        //defaults
        context.themes = context.themes || [];
        context.events = context.events || [];
        context.persons = context.persons || [];
        context.organizations = context.organizations || [];
        context.geolocs = context.geolocs || [];

        T.$el.html(T.template(context));

        T.updateMetadatas(context);

        return T;
    },

    /**
     * mise à jour des meta relatives à la page
     * ça aurait plus sa place dans le reader, mais bon ...
     */
    updateMetadatas: function(context) {
        var T=this;
        var page_width = T.pageModel.get("width"),
            page_height = T.pageModel.get("height"),
            thumbnail_max_width = 300,
            thumbnail_max_height = 400,
            thumbnail_width, thumbnail_height;

        var k = thumbnail_max_height / page_height;
        thumbnail_width = Math.round(k * page_width);

        if (thumbnail_width > thumbnail_max_width) {
            k = thumbnail_max_width / page_width;
            thumbnail_width = thumbnail_max_width;
            thumbnail_height = Math.round(k * page_height);
        } else {
            thumbnail_height = thumbnail_max_height;
        }

        var description="Archives de presse BnF";

        if(context.events.length){
            description+=" "+context.events.join(" ");
        }
        if(context.persons.length){
            description+=" "+context.persons.join(" ");
        }
        if(context.organizations.length){
            description+=" "+context.organizations.join(" ");
        }
        if(context.geolocs.length){
            description+=" "+context.geolocs.join(" ");
        }

        UrlUtil.meta("name", "description", description);

        UrlUtil.meta("property", "og:image:width", thumbnail_width);
        UrlUtil.meta("property", "og:image:height", thumbnail_height);
        UrlUtil.meta("property", "og:description", description);

        UrlUtil.meta("name", "twitter:description", description);

    },


    onTagClicked: function(e) {
        var T = this,
            $target = $(e.target),
            type = $target.data("type"),
            search_str = "/search#advancedUi=false&documentType=page&sort=score",
            value = $target.data("value");

        if (type == "theme") {
            var l1 = $target.data("l1"),
                l2 = $target.data("l2");

            search_str += "&tfThemes[0][l1]=" + l1 + "&tfThemes[0][l2]=" + l2;
        } else if (type == "event") {
            search_str += "&tfEvents[0]=" + value;
        } else {
            // ici on précise le terme pour avoir un highlight, contrairement à theme et event qui n'ont pas de correspondance dans le texte
            search_str += "&allTerms=" + value;
            if (type == "person") {
                search_str += "&tfPersons[0]=" + value;
            } else if (type == "geoloc") {
                search_str += "&tfGeolocs[0]=" + value;
            } else if (type == "organization") {
                search_str += "&tfOrganizations[0]=" + value;
            }
        }

        if (T.userModel.isPremium()) {
            window.location = search_str;
        } else {
            T.app.premiumScreen();
        }

    },

    onPageChanged: function() {
        var T = this;

        if (T.pageModel) {
            T.stopListening(T.pageModel);
            T.pageModel = null;
        }
        T.pageModel = T.model.getPageModel(T.model.get("page"));

        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    close: function() {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }

});